import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Obr from "../images/katherine-volkovski-Q_MJjEN14uk-unsplash.jpg"

const SecondPage = () => (
  <Layout>
    <SEO title="Hybrid kukurice Citrinia" />
    <section className="text-gray-700 body-font overflow-hidden">
      <div className="container px-5 py-24 mx-auto">
        <div className="lg:w-4/5 mx-auto flex flex-wrap">
          <div className="lg:w-1/2 w-full lg:pr-10 lg:py-6 mb-6 lg:mb-0">
            <h2 className="text-sm title-font text-gray-500 tracking-widest">
              FAO 210
            </h2>
            <h1 className="text-gray-900 text-3xl title-font font-medium mb-4">
              Citrinia
            </h1>
            <div className="flex mb-4">
              <span className="flex-grow text-indigo-500 border-b-2 border-indigo-500 py-2 text-lg px-1">
                Odporúčania pre pestovateľov
              </span>
            </div>
            <p className="leading-relaxed text-justify mb-4">
              Hybrid CITRINIA je vhodný pre pestovanie na siláž do chladnejších
              podmienok v podhorskej výrobnej oblasti vzhľadom na svoju skorosť.
              Je tu možné využiť neskorší výsev po období výskytu neskorých
              jarných mrazíkov a skorší zber pred príchodom skorých jesenných
              mrazíkov. Vzhľadom na vyšší podiel šúľkov a relatívne nižšiu výšku
              porastu je možné použiť zahustenie až na 110 000 rastlín na ha.
              Pre pestovanie na zrno, CCM a LKS je ale vhodné prispôsobiť
              organizáciu porastu na 90 000 rastlín na ha. V teplejších
              oblastiach s vyššou zásobenosťou vodou a vzhľadom na uvedenú
              skorosť je možné aj využitie ako medziplodiny.
            </p>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Typ hybridu</span>
              <span className="ml-auto text-gray-900">Tc</span>
            </div>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Typ zrna</span>
              <span className="ml-auto text-gray-900">medzityp</span>
            </div>

            <div className="flex py-2">
              <span className="title-font font-medium text-2xl text-gray-900">
                Organizácia porastu:
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">
                Pestovanie na siláž v podhorskej a zemiakovej oblasti
              </span>
              <span className="ml-auto text-gray-900">
                110 000 <span className="text-xs">rastlín na ha</span>
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2 mb-6">
              <span className="text-gray-500">
                Pestovanie na zrno v repnej oblasti
              </span>
              <span className="ml-auto text-gray-900">
                90 000 <span className="text-xs">rastlín na ha</span>
              </span>
            </div>

            <div className="flex py-2">
              <span className="title-font font-medium text-2xl text-gray-900">
                Hospodárske vlastnosti:
              </span>
            </div>

            <div className="flex border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Relatívne vyšší podiel šúľkov a zrna
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Adaptabilita k vyšším hustotám porastu
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Rýchly nárast a nalievanie šúľkov
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Vysoká kvalita silážnej hmoty
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Skorosť pre pestovanie kukurice na siláž v podhorskej
                    oblasti
                  </span>
                </div>
              </div>
            </div>
          </div>
          <img
            alt="Hybrid kukurice Citrinia"
            className="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded"
            src={Obr}
          />
        </div>
      </div>
    </section>

    <div className="lg:w-2/3 w-full mx-auto overflow-auto py-4 mb-6">
      <h2 className="text-2xl text-gray-900 text-center font-medium leading-none py-4 mb-6 mt-2">
        Výsledky zo štátnych odrodových pokusov v rokoch 2010-2011 (priemery
        lokalít):
      </h2>

      <table className="table-auto w-full text-left whitespace-no-wrap py-2">
        <thead>
          <tr>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl">
              Úroda
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              CITRINIA
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              LG3225
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-4 py-3 "> suchých šúľkov (t/ha)</td>
            <td className="bg-gray-100 px-4 py-3 ">9,56</td>
            <td className="px-4 py-3">8,51</td>
          </tr>
          <tr>
            <td className="border-t-2 border-gray-300 bg-gray-300 px-4 py-3 rounded-bl rounded-tl">
              Sušina zrna (%)
            </td>
            <td className="border-t-2 bg-gray-100 px-4 py-3">51,30</td>
            <td className="border-t-2 border-gray-300 bg-gray-300 px-4 py-3">
              48,60
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div className="lg:w-2/3 w-full mx-auto overflow-auto py-4 mb-6">
      <h2 className="text-2xl text-gray-900 text-center font-medium leading-none py-4 mb-6 mt-2">
        Výsledky zo štátnych odrodových pokusov v podhorskej oblasti v roku
        2011:
      </h2>

      <table className="table-auto w-full text-left whitespace-no-wrap py-2">
        <thead>
          <tr>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl">
              Úroda
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              CITRINIA
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              LG3225
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-4 py-3 "> suchých šúľkov (t/ha)</td>
            <td className="bg-gray-100 px-4 py-3 ">13,68</td>
            <td className="px-4 py-3">12,37</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-300"> Sušina zrna (%)</td>
            <td className="bg-gray-100 px-4 py-3 ">64,30</td>
            <td className="px-4 py-3 bg-gray-300">45,70</td>
          </tr>
        </tbody>
      </table>
    </div>
  </Layout>
)

export default SecondPage
